import { render, staticRenderFns } from "./MvpComparison.vue?vue&type=template&id=e832dcd0&scoped=true&"
import script from "./MvpComparison.vue?vue&type=script&lang=js&"
export * from "./MvpComparison.vue?vue&type=script&lang=js&"
import style0 from "./MvpComparison.vue?vue&type=style&index=0&id=e832dcd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e832dcd0",
  null
  
)

export default component.exports